import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type { FetchModelosCartaArArgs, ModelosCartaArPagina } from '../../types/arModelosCarta';

const unwrap = <T>(body: unknown): T => {
  if (typeof body === 'object' && body !== null && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
};

export const modelosCartaArService = {
  /**
   * Rota própria da Secretaria, e não `GET /admin/arbitral/letter-templates`: aquela
   * exige admin-master (a Secretaria leva 403) e não pagina.
   *
   * O servidor já devolve só os ATIVOS da empresa — oferecer um modelo inativado
   * congelaria na solicitação uma carta que ninguém deveria mais imprimir.
   */
  listar: async (args: FetchModelosCartaArArgs): Promise<ModelosCartaArPagina> => {
    const params: Record<string, string | number> = { page: args.page, limit: args.limit };
    if (args.search?.trim()) params.search = args.search.trim();

    const response = await apiGet('/admin/arbitral/ar/modelos-carta', params);
    if (!response.ok) await throwApiError(response, 'Erro ao carregar os modelos de carta');

    const pagina = unwrap<ModelosCartaArPagina>((await response.json()) as unknown);
    return {
      items: pagina?.items ?? [],
      total: pagina?.total ?? 0,
      page: pagina?.page ?? args.page,
      limit: pagina?.limit ?? args.limit,
      hasMore: pagina?.hasMore ?? false,
    };
  },
};
